import { useEffect, useState } from "react";
import FontFaceObserver from "fontfaceobserver";

// Waits for a font to load before the app renders. The font itself is self-hosted
// and declared with @font-face in public/index.html
const useFont = (fontName: string) => {
  const [ loaded, setLoaded ] = useState(false);

  useEffect(() => {
    const font = new FontFaceObserver(fontName, { weight: 400 });
    font.load().then(() => {
      setLoaded(true);
    }, () => {
      setLoaded(true);
    });
  }, [ fontName ]);

  return loaded;
};

export default useFont;
